import { MaybeRef } from '@vueuse/core'
import { unref } from 'vue'
import { Order } from '../store/useOrders'

type UseOrderItemRulesReturn = {
  itemNotNull: (val: string | number) => boolean
  quantityAboveZero: (val: number) => boolean
  quantityAboveEqualZero: (val: number) => boolean
  noDecimalPlace: (val: number) => boolean
  all: () => boolean
}
type OrderFormData = {
  quantity: MaybeRef<Order['quantity']>
  reason: MaybeRef<Order['reason']>
}
/** Validations for ModalOrderItem form */
export const useOrderItemRules = (formData: OrderFormData): UseOrderItemRulesReturn => {
  const itemNotNull = (val: string | number | { [key: string]: any }) =>
    val !== null && typeof val !== 'undefined'
  const quantityAboveZero = (val: number) => val > 0
  const quantityAboveEqualZero = (val: number) => val >= 0
  const noDecimalPlace = (val: number) => val % 1 === 0
  const all = () => {
    return (
      itemNotNull(unref(formData.quantity)) &&
      itemNotNull(unref(formData.reason)) &&
      quantityAboveZero(unref(formData.quantity))
    )
  }
  return {
    itemNotNull,
    quantityAboveZero,
    quantityAboveEqualZero,
    noDecimalPlace,
    all,
  }
}
